import React, {useState} from 'react';
import { useLocation } from 'react-router-dom'
import { Link } from "react-router-dom";
import CardItem from "./Main/CardItem";

function Browse() {
    const [result,setResult] = useState([
        {
            id:1,
            name: 'دم سینگ',
            artistName: 'دورچی',
            image: 'https://i1.sndcdn.com/artworks-MhBX8k6Nl86P4uri-Aan0Eg-t240x240.jpg',
        },
        {
            id:1,
            name: 'ران اوی',
            artistName: 'پوبون',
            image: 'https://i1.sndcdn.com/artworks-GKTNcA6vqiYOkjXy-YBztUw-t500x500.jpg',
        },
        {
            id:1,
            name: 'ساقی',
            artistName: 'کوروش',
            image: 'https://assets.rjassets.com/static/mp3/the-don-saaghi-(ft-koorosh)/7828a2bfb8cb100.jpg',
        },
        {
            id:1,
            name: 'فنا',
            artistName: 'آرتا',
            image: 'https://i1.sndcdn.com/artworks-WPHhQiAEXdn4VSLw-y42iBg-t500x500.jpg',
        },
        {
            id:1,
            name: 'یایا',
            artistName: 'کپی بیتز',
            image: 'https://i1.sndcdn.com/avatars-nxeIBJ4MRHysrH2u-UNJMwQ-t500x500.jpg',
        },
        {
            id:1,
            name: 'شاخ قرمر',
            artistName: 'پوتک',
            image: 'https://i1.sndcdn.com/avatars-KAblOPuUX61dQU9c-OH8exA-t500x500.jpg',
        },
        {
            id:1,
            name: 'دم سینگ',
            artistName: 'دورچی',
            image: 'https://i1.sndcdn.com/artworks-MhBX8k6Nl86P4uri-Aan0Eg-t240x240.jpg',
        },
        {
            id:1,
            name: 'ران اوی',
            artistName: 'پوبون',
            image: 'https://i1.sndcdn.com/artworks-GKTNcA6vqiYOkjXy-YBztUw-t500x500.jpg',
        },
        {
            id:1,
            name: 'ساقی',
            artistName: 'کوروش',
            image: 'https://assets.rjassets.com/static/mp3/the-don-saaghi-(ft-koorosh)/7828a2bfb8cb100.jpg',
        },
        {
            id:1,
            name: 'فنا',
            artistName: 'آرتا',
            image: 'https://i1.sndcdn.com/artworks-WPHhQiAEXdn4VSLw-y42iBg-t500x500.jpg',
        },
        {
            id:1,
            name: 'یایا',
            artistName: 'کپی بیتز',
            image: 'https://i1.sndcdn.com/avatars-nxeIBJ4MRHysrH2u-UNJMwQ-t500x500.jpg',
        },
        {
            id:1,
            name: 'شاخ قرمر',
            artistName: 'پوتک',
            image: 'https://i1.sndcdn.com/avatars-KAblOPuUX61dQU9c-OH8exA-t500x500.jpg',
        },
        {
            id:1,
            name: 'دم سینگ',
            artistName: 'دورچی',
            image: 'https://i1.sndcdn.com/artworks-MhBX8k6Nl86P4uri-Aan0Eg-t240x240.jpg',
        },
        {
            id:1,
            name: 'ران اوی',
            artistName: 'پوبون',
            image: 'https://i1.sndcdn.com/artworks-GKTNcA6vqiYOkjXy-YBztUw-t500x500.jpg',
        },
        {
            id:1,
            name: 'ساقی',
            artistName: 'کوروش',
            image: 'https://assets.rjassets.com/static/mp3/the-don-saaghi-(ft-koorosh)/7828a2bfb8cb100.jpg',
        },
        {
            id:1,
            name: 'فنا',
            artistName: 'آرتا',
            image: 'https://i1.sndcdn.com/artworks-WPHhQiAEXdn4VSLw-y42iBg-t500x500.jpg',
        },
        {
            id:1,
            name: 'یایا',
            artistName: 'کپی بیتز',
            image: 'https://i1.sndcdn.com/avatars-nxeIBJ4MRHysrH2u-UNJMwQ-t500x500.jpg',
        },
        {
            id:1,
            name: 'شاخ قرمر',
            artistName: 'پوتک',
            image: 'https://i1.sndcdn.com/avatars-KAblOPuUX61dQU9c-OH8exA-t500x500.jpg',
        },
        {
            id:1,
            name: 'دم سینگ',
            artistName: 'دورچی',
            image: 'https://i1.sndcdn.com/artworks-MhBX8k6Nl86P4uri-Aan0Eg-t240x240.jpg',
        },
        {
            id:1,
            name: 'ران اوی',
            artistName: 'پوبون',
            image: 'https://i1.sndcdn.com/artworks-GKTNcA6vqiYOkjXy-YBztUw-t500x500.jpg',
        },
        {
            id:1,
            name: 'ساقی',
            artistName: 'کوروش',
            image: 'https://assets.rjassets.com/static/mp3/the-don-saaghi-(ft-koorosh)/7828a2bfb8cb100.jpg',
        },
        {
            id:1,
            name: 'فنا',
            artistName: 'آرتا',
            image: 'https://i1.sndcdn.com/artworks-WPHhQiAEXdn4VSLw-y42iBg-t500x500.jpg',
        },
        {
            id:1,
            name: 'یایا',
            artistName: 'کپی بیتز',
            image: 'https://i1.sndcdn.com/avatars-nxeIBJ4MRHysrH2u-UNJMwQ-t500x500.jpg',
        },
        {
            id:1,
            name: 'شاخ قرمر',
            artistName: 'پوتک',
            image: 'https://i1.sndcdn.com/avatars-KAblOPuUX61dQU9c-OH8exA-t500x500.jpg',
        },
        {
            id:1,
            name: 'دم سینگ',
            artistName: 'دورچی',
            image: 'https://i1.sndcdn.com/artworks-MhBX8k6Nl86P4uri-Aan0Eg-t240x240.jpg',
        },
        {
            id:1,
            name: 'ران اوی',
            artistName: 'پوبون',
            image: 'https://i1.sndcdn.com/artworks-GKTNcA6vqiYOkjXy-YBztUw-t500x500.jpg',
        },
        {
            id:1,
            name: 'ساقی',
            artistName: 'کوروش',
            image: 'https://assets.rjassets.com/static/mp3/the-don-saaghi-(ft-koorosh)/7828a2bfb8cb100.jpg',
        },
        {
            id:1,
            name: 'فنا',
            artistName: 'آرتا',
            image: 'https://i1.sndcdn.com/artworks-WPHhQiAEXdn4VSLw-y42iBg-t500x500.jpg',
        },
        {
            id:1,
            name: 'یایا',
            artistName: 'کپی بیتز',
            image: 'https://i1.sndcdn.com/avatars-nxeIBJ4MRHysrH2u-UNJMwQ-t500x500.jpg',
        },
        {
            id:1,
            name: 'شاخ قرمر',
            artistName: 'پوتک',
            image: 'https://i1.sndcdn.com/avatars-KAblOPuUX61dQU9c-OH8exA-t500x500.jpg',
        },
    ])
    const location = useLocation()
    console.log('STATE',location.state)
    return (
        <div className='flex flex-col'>
            <div className='text-violet-800 font-black text-base md:text-lg mb-6'>{location.state.title}</div>
            <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-5 xl:grid-cols-6 gap-y-4">
                {
                    result.map((item) =>
                        <div className='flex flex-col justify-self-center justify-center text-center text-sm'>
                            <img src={item.image} alt={item.name} className='w-[80px] h-[80px] sm:w-[120px] sm:h-[120px] md:w-[120px] md:h-[120px] xl:w-[150px] xl:h-[150px] rounded mb-2'/>
                            <Link to={`/album/1`} >
                                <div className="font-medium mb-1 cursor-pointer hover:underline underline-offset-4 transition">{item.name}</div>
                            </Link>
                            <Link to={`/artist/5`} >
                                <div className="cursor-pointer hover:underline underline-offset-4 transition">{item.artistName}</div>
                            </Link>

                        </div>
                    )
                }
            </div>
        </div>
    );
}

export default Browse;